import { render } from "./DecolopTeamActionsOverview.vue?vue&type=template&id=76be3a19"
import script from "./DecolopTeamActionsOverview.vue?vue&type=script&lang=js"
export * from "./DecolopTeamActionsOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__